import { constVoid, DOM, IOO, pipe, RNEA, RR, s, v } from '@packages/prelude'
import { Swiper, SwiperOptions, Autoplay, Navigation, Pagination, EffectFade } from 'swiper'

import 'bootstrap'
import '../css/main.scss'

pipe(
  IOO.of({ document }),
  IOO.bind('navbar', ({ document }) => pipe(document, DOM.querySelector('.navbar'))),
  IOO.map(({ navbar }) =>
    DOM.addEventListener('scroll')(() => () => navbar.classList.toggle('floating', window.scrollY > 0))(document)()
  )
)()

pipe(
  IOO.of({ document }),
  IOO.bind('submenu', ({ document }) => pipe(document, DOM.querySelector('.onpage-menu-block'))),
  IOO.bind(
    'collapseBtn',
    ({ submenu }) => pipe(submenu, DOM.querySelector('.collapse-button')) as unknown as IOO.IOOption<HTMLElement>
  ),
  IOO.bind('links', ({ submenu }) => pipe(submenu, DOM.querySelectorAll('ul > li'))),
  IOO.map(({ submenu, collapseBtn, links }) => {
    DOM.addEventListener('scroll')(() => () => submenu.classList.toggle('d-block', window.scrollY > 0))(document)()
    pipe(
      links,
      RNEA.map(link => DOM.addEventListener('click')(() => () => collapseBtn.click())(link)())
    )
  })
)()

const makeSwiper = (selector: string, options: SwiperOptions) =>
  pipe(
    IOO.of({ document }),
    IOO.chain(
      ({ document }) =>
        pipe(document, DOM.querySelectorAll(`.${selector}`)) as IOO.IOOption<RNEA.ReadonlyNonEmptyArray<HTMLElement>>
    ),
    IOO.fold(
      () => constVoid,
      elements =>
        IOO.of(
          pipe(
            elements,
            RNEA.map(element => new Swiper(element, options))
          )
        )
    )
  )()

const Swipers: Record<string, SwiperOptions> = {
  'hero-swiper': {
    direction: 'horizontal',
    modules: [Autoplay, EffectFade],
    loop: true,
    speed: 1000,
    slidesPerView: 1,
    autoplay: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    }
  },
  'footer-swiper': {
    direction: 'horizontal',
    modules: [Autoplay],
    loop: true,
    speed: 750,
    slidesPerView: 2,
    breakpoints: {
      720: {
        slidesPerView: 4
      }
    },
    spaceBetween: 10,
    autoplay: true
  },
  'content-swiper': {
    direction: 'horizontal',
    modules: [Navigation, Pagination],
    loop: true,
    speed: 750,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  },
  'announcements-swiper': {
    direction: 'horizontal',
    modules: [Navigation],
    loop: false,
    speed: 750,
    slidesPerView: 1,
    breakpoints: {
      720: {
        slidesPerView: 2
      }
    },
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-announcements-button-next',
      prevEl: '.swiper-announcements-button-prev'
    }
  },
  'news-swiper': {
    direction: 'horizontal',
    modules: [Navigation],
    loop: false,
    speed: 750,
    slidesPerView: 1,
    breakpoints: {
      720: {
        slidesPerView: 2
      }
    },
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-news-button-next',
      prevEl: '.swiper-news-button-prev'
    }
  }
}

pipe(
  Swipers,
  RR.foldMapWithIndex(s.Ord)(v.Monoid)((selector, options) => makeSwiper(selector, options))
)
